import PropTypes from 'prop-types';
import { useContext } from 'react';
import Modal from 'react-modal';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { RuntimeContext } from '../../../../common/RuntimeContext';
import { putUserPathway } from '../../../shared/actions/UserPathways';
import { SEGMENT_EVENTS } from '../../../shared/Constants';
import { getModalStyling } from '../../../shared/utils/ModalUtils';
import MyPathway from '../../components/widgets/PathwayPanelWidget/MyPathway';

const PathwayTimelineModal = (props) => {
    const config = useContext(RuntimeContext);
    const {
        userPathway,
        collectionsById,
        userCollectionsById,
        loggedInUserCompany,
        isVerbAdmin,
        history,
        isOpen,
        handleModalClose,
        putUserPathway
    } = props;

    const updateUserPathwayContentItem = (milestone, idx = null) => {
        const milestoneIdx = milestone.pathwayContentIndex?.toString() || idx?.toString();

        if (milestoneIdx) {
            const newStatus = userPathway.content[milestoneIdx].status === 'COMPLETED' ? 'ASSIGNED' : 'COMPLETED';
            userPathway.content[milestoneIdx].status = newStatus;
            userPathway.content[milestoneIdx].isCompleted = !userPathway.content[milestoneIdx].isCompleted;
        }
        const putBody = {
            userPathwayId: userPathway._id,
            body: {
                pathwayId: userPathway.pathwayId,
                name: userPathway.name,
                content: userPathway.content,
                revision: userPathway.revision
            },
            pathsContext: config.pathsWeb
        };
        const segmentInfo = {
            dateTime: milestone.date,
            taskName: milestone.name,
            pathwayName: userPathway.name,
            licenseType: userPathway.subscriptionType
        };
        return putUserPathway(putBody);
    };

    return (
        <Modal
            className={'team-pathway-modal modal-container'}
            style={getModalStyling({
                content: { padding: '0 15px 25px 15px', maxHeight: '90%', borderRadius: 'none' }
            })}
            isOpen={isOpen}
            contentLabel={'Modal'}
            ariaHideApp={false}
        >
            <div className={'close-container'}>
                <i className={'fal fa-times'} onClick={handleModalClose} />
            </div>
            <MyPathway
                userPathway={userPathway}
                collectionsById={collectionsById}
                userCollectionsById={userCollectionsById}
                loggedInUserCompany={loggedInUserCompany}
                isVerbAdmin={isVerbAdmin}
                isMobile={false}
                history={history}
                toggleCalendarModal={() => {}}
                isTeamPage={true}
                updateUserPathwayContentItem={updateUserPathwayContentItem}
            />
        </Modal>
    );
};

PathwayTimelineModal.propTypes = {
    userPathway: PropTypes.object,
    collectionsById: PropTypes.object,
    userCollectionsById: PropTypes.object,
    loggedInUserCompany: PropTypes.object,
    isVerbAdmin: PropTypes.bool,
    history: PropTypes.object,
    isOpen: PropTypes.bool,
    handleModalClose: PropTypes.func,
    putUserPathway: PropTypes.func
};

const mapStateToProps = (state, ownProps) => {
    const {
        collections,
        userCollections,
        userPathways,
        companies,
        auth: { loggedInUserCompanyId, isVerbAdmin }
    } = state;
    const { userPathwayId } = ownProps;
    const loggedInUserCompany = companies.byId[loggedInUserCompanyId];
    const userPathway = userPathways.byId[userPathwayId];
    return {
        userCollectionsById: userCollections.byId,
        collectionsById: collections.byId,
        isVerbAdmin,
        loggedInUserCompany,
        userPathway
    };
};

const mapDispatchToProps = (dispatch) => ({
    putUserPathway: (params) => dispatch(putUserPathway(params))
});

export const PathwayTimelineModalComponent = PathwayTimelineModal;
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PathwayTimelineModal));
